import * as z from "zod";

const WindDirectionEnumDto = {
    N: "N",
    NE: "NE",
    E: "E",
    SE: "SE",
    S: "S",
    SW: "SW",
    W: "W",
    NW: "NW",
} as const;
export type WindDirectionEnumDto =
    (typeof WindDirectionEnumDto)[keyof typeof WindDirectionEnumDto];
const WindDirectionEnumDtoSchema = z.enum(WindDirectionEnumDto);

export const WeatherDayDtoSchema = z.object({
    date: z.string().trim(),
    etc: z.number().nullable(),
    eto: z.number().nullable(),
    kc: z.number().nullable(),
    humidity: z.number(),
    wind_speed_from: z.number(),
    wind_speed_to: z.number(),
    wind_direction: WindDirectionEnumDtoSchema,
    sunset: z.string().trim(),
    sunrise: z.string().trim(),
    icon: z.string().trim(),
    rain_prob: z.number(),
    rain_fall: z.number(),
    min_temp: z.number(),
    max_temp: z.number(),
});
export type WeatherDayDto = z.output<typeof WeatherDayDtoSchema>;
